import React from 'react';
import { Form } from 'react-bootstrap';

const Color = props => {
  return (
    <Form.Group className={'mb-3 d-flex'}>
      <Form.Label className={'col m-auto'}>{props.item.title}</Form.Label>
      <div className={'col'}>
        <Form.Control
          className="w-100"
          type="color"
          defaultValue={props.value}
          onChange={props.onChange.bind(this, props.item.name)}
        />
      </div>
    </Form.Group>
  );
};

export default Color;
